import PgFilters from './PgFilters.container';

export default PgFilters;
